<template>
    <div>
        沒有瀏覽權限，如要操作線上交易請重新登入
    </div>
</template>
<script>

export default {
};
</script>
